document.addEventListener('DOMContentLoaded', function () {
    var pwdInput   = document.getElementById('reg_password');
    var feedbackEl = document.getElementById('password_feedback');

    if (!pwdInput || !feedbackEl) {
        return;
    }

    // You can localize these if needed for translation
    var ruleText = 'Weak - Please enter a stronger password.';
    var okText   = 'Strong';

    var strongPattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*(?:\d|[!"?$%^&\)]))[A-Za-z\d!"?$%^&\)]{12,}$/;

    feedbackEl.className = 'login__password-feedback';
    feedbackEl.textContent = ruleText;

    pwdInput.addEventListener('keyup', function () {
        if (strongPattern.test(pwdInput.value)) {
            feedbackEl.className = 'login__password-feedback valid';
            feedbackEl.textContent = okText;
        } else {
            feedbackEl.className = 'login__password-feedback invalid';
            feedbackEl.textContent = ruleText;
        }
    });
});